var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.22266,
    y: 7.5,
    width: 14.7778,
    height: 14.7778,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.125C7.71641 3.125 2.625 8.21641 2.625 14.5C2.625 20.7836 7.71641 25.875 14 25.875C20.2836 25.875 25.375 20.7836 25.375 14.5C25.375 8.21641 20.2836 3.125 14 3.125ZM12.2445 18.5305C12.1133 18.6617 11.9273 18.7711 11.7633 18.7711C11.5992 18.7711 11.4133 18.6562 11.2766 18.525L8.21406 15.4625L9.1875 14.4891L11.7688 17.0703L18.5938 10.1961L19.5508 11.1859L12.2445 18.5305Z",
    fill: "#4DB881"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.ec68c539f2058f80c5c807fb5be31157.svg";
export { ForwardRef as ReactComponent };